import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import "../styles/EditarContenedorModal.css";

const EditarContenedorModal = ({
  isOpen,
  onClose,
  contenedor,
  language,
  onSave,
}) => {
  const [formData, setFormData] = useState({});

  const translations = {
    es: {
      titulo: "Editar Contenedor",
      guardar: "Guardar",
      cancelar: "Cancelar",
      campos: {
        IdContenedor: "ID Contenedor",
        sNroContenedor: "Número de Contenedor",
        idEstadoContenedor: "Estado del Contenedor",
        iMedida: "Medida",
        sSerial: "Serial",
        //iCantidadCajas: 'Cantidad de Cajas',
        dFechaDespacho: "Fecha de Despacho",
        //dPesoNeto: 'Peso Neto',
        //dPesoBruto: 'Peso Bruto',
        mDescripcion: "Descripción",
        sNombreEstadoContenedor: "Estado Actual",
      },
    },
    en: {
      titulo: "Edit Container",
      guardar: "Save",
      cancelar: "Cancel",
      campos: {
        IdContenedor: "Container ID",
        sNroContenedor: "Container Number",
        idEstadoContenedor: "Container Status",
        iMedida: "Measurement",
        sSerial: "Serial",
        //iCantidadCajas: 'Box Quantity',
        dFechaDespacho: "Dispatch Date",
        //dPesoNeto: 'Net Weight',
        //dPesoBruto: 'Gross Weight',
        mDescripcion: "Description",
        sNombreEstadoContenedor: "Current Status",
      },
    },
    zh: {
      titulo: "编辑集装箱",
      guardar: "保存",
      cancelar: "取消",
      campos: {
        IdContenedor: "集装箱ID",
        sNroContenedor: "集装箱号",
        idEstadoContenedor: "集装箱状态",
        iMedida: "测量",
        sSerial: "序列号",
        // iCantidadCajas: '箱子数量',
        dFechaDespacho: "发货日期",
        // dPesoNeto: '净重',
        // dPesoBruto: '毛重',
        mDescripcion: "描述",
        sNombreEstadoContenedor: "当前状态",
      },
    },
  };

  const t = translations[language] || translations.es;

  useEffect(() => {
    if (contenedor) {
      setFormData({ ...contenedor });
    }
  }, [contenedor]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Datos enviados al guardar:", formData);

    // Validación previa
    if (!formData.IdContenedor) {
      alert("Error: El ID del contenedor es obligatorio.");
      return;
    }

    // Función para formatear fechas en formato MySQL TIMESTAMP
    const formatTimestamp = (date) => {
      if (!date) return null; // Si la fecha es null o undefined
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // Procesar fechas antes de enviarlas al backend
    const updatedFormData = {
      ...formData,
      dFechaDespacho: formatTimestamp(formData.dFechaDespacho),
      usrmodificacion: "UsuarioActual", // Cambia por el usuario actual
    };

    // Llamar a la función onSave con los datos actualizados
    onSave(updatedFormData);
  };

  return (
    <Dialog
      header={t.titulo}
      visible={isOpen} // 🔹 Ahora el modal se muestra correctamente
      style={{ width: "50vw" }}
      modal
      onHide={onClose}
    >
      <div className="p-fluid form-grid">
        {Object.keys(t.campos)
          .filter((fieldKey) => fieldKey !== "idEstadoContenedor")
          .map((fieldKey) => {
            const currentKey = fieldKey; // Captura local para evitar no-loop-func
            return (
              <div className="field" key={currentKey}>
                <label htmlFor={currentKey}>{t.campos[currentKey]}</label>
                {currentKey === "dFechaDespacho" ? (
                  <Calendar
                    id={`editar-contenedor-${currentKey}`}
                    value={
                      formData[currentKey]
                        ? new Date(formData[currentKey])
                        : null
                    }
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [currentKey]: e.value
                          ? new Date(e.value).toISOString()
                          : null,
                      }))
                    }
                    showTime
                    dateFormat="dd/mm/yy"
                  />
                ) : currentKey === "idEstadoContenedor" ? (
                  <InputText
                    id={`editar-contenedor-${currentKey}`}
                    name={currentKey}
                    value={formData.sNombreEstadoContenedor || ""}
                    readOnly
                  />
                ) : (
                  <InputText
                    id={`editar-contenedor-${currentKey}`}
                    name={currentKey}
                    value={formData[currentKey] || ""}
                    onChange={handleInputChange}
                    readOnly={
                      currentKey === "sNombreEstadoContenedor" ||
                      currentKey === "IdContenedor"
                    }
                    className={
                      currentKey === "sNombreEstadoContenedor" ||
                      currentKey === "IdContenedor"
                        ? "readonly-field"
                        : ""
                    }
                    autoComplete="new-password"
                  />
                )}
              </div>
            );
          })}
      </div>
      <div style={{ marginTop: "20px" }}></div>
      <div className="p-dialog-footer">
        <Button
          id="btn-editar-contenedor-guardar"
          label={t.guardar}
          icon="pi pi-check"
          className="p-button-success"
          onClick={handleSave}
        />
        <Button
          id="btn-editar-contenedor-cancelar"
          label={t.cancelar}
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={onClose}
        />
      </div>
    </Dialog>
  );
};

export default EditarContenedorModal;
